<template>
  <Breadcrumb />
  <div class="d-flex justify-content-end">
    <router-link to="New" class="btn btn-success btn-action-new-page"
      ><i class="bi bi-plus"></i>
      {{
        $t(
          "ProjectParameters.NewButton",
          {},
          { locale: this.$store.state.activeLang }
        )
      }}</router-link
    >
  </div>
  <Grid :settings="gridSettings" :columns="gridColumns" />
</template>
<script>
export default {
  name: "CompanyParameterList",
  components: {},
  data() {
    return {
      gridSettings: {
        action: "CompanyParameterList",
        requestUrl: String.format("/Lcdp-CompanyParameterList"),
        requestUrlRouteParamNames: [],
        routeRequiredParameters: [
          {
            key: "companyParameterId",
            value: "publicId",
            isRouteParameter: false,
          },
        ],

        serialNoLink: `#/CompanyParameter/Edit/`,
        isGatewayRequest: true,

        allowSearchPanel: true,
        allowExcelExport: true,
        allowDragAndDrop: false,
        allowPaging: true,
        allowDeleting: true,
        deleteActionUrl: "/Lcdp-CompanyParameterDelete",
        autoOrderProcess: true,

        buttons: [
          {
            name: "edit",
            cssClass: "btn-warning",
            iconClass: "bi-pencil-square",
            routeButton: true,
            routeObj: {
              name: "CompanyParameterEdit",
              params: {
                companyParameterId: "",
              },
            },
          },
        ],
      },
      gridColumns: [
        {
          text: this.$t(
            "ProjectParameters.Name",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "name",
          type: "string",
          visible: true,
          width: 400,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "ProjectParameters.Value",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "value",
          type: "string",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
